import React, {Component} from "react";
import {ContentModelName} from "../contenful/types";
import {connect} from "react-redux";
import {AppState} from "../RootReducer";
import {fetchContent} from "../contenful/ContentfulActions";
import {Dispatch} from "redux";
import {Spinner} from "../ui/Spinner";
import ProfilePageComponent from "./ProfilePageComponent";
import {fetchSettings} from "../settings/SettingsActions";
import {AccountBalance, Settings, TransferLimit, UserInfo} from "../http/protocol";
import {RouteComponentProps} from "react-router";
import {withdrawAmountValidCheck} from "../utils/Money";
import {getLoggedIn} from "../selectors/user-selectors";
import "../ui/AccountPages.scss";

interface State {
    animate: boolean;
}

type AllProps = PropsFromState & PropsFromDispatch & OtherProps;

export class ProfilePage extends Component<AllProps, State> {
    constructor(props: AllProps) {
        super(props);

        this.state = {
            animate: false,
        }
    }

    componentDidMount(): void {
        window.scroll(0,0)
        this.setState({animate: true});

        if(this.props.settings == undefined) {
            this.props.fetchSettings();
        }
    }

    componentDidUpdate(prevProps: AllProps): void {
    }

    handleGoBack = () => {
        this.props.history.goBack();
    };

    render() {

        let firstCurr = this.props.balances && this.props.balances[0] && this.props.balances[0].balance && this.props.balances[0].balance.currencyCode;
        let activeCurrency = this.props.balances && this.props.balances[0] && this.props.activeCurrency ? this.props.activeCurrency : firstCurr;
        let activeCurr = this.props.settings && this.props.settings.forceWithdrawCurrency ? this.props.settings.forceWithdrawCurrency : activeCurrency;
        let withdrawAmountValid:any = this.props.balances && activeCurr && this.props.transferLimits && withdrawAmountValidCheck(this.props.balances, activeCurr, this.props.transferLimits);
        let minWithdrawValid = withdrawAmountValid && withdrawAmountValid.minWithdrawValid;
        const {isFetching, loggedIn, user, settings} = this.props;


        return (
            <div>
                {
                    isFetching
                        ? <Spinner />
                        : (
                            minWithdrawValid!=undefined && settings&& (
                                <ProfilePageComponent
                                    minWithdrawValid={minWithdrawValid}
                                    settings={settings}
                                    user={user}
                                    animate={this.state.animate}
                                    goBack={this.handleGoBack} />
                            )
                        )
                }
            </div>
        )
    }

}

interface OtherProps extends RouteComponentProps {
}

interface PropsFromState {
    isFetching: boolean;
    settings?: Settings;
    loggedIn: boolean;
    user?: UserInfo;
    balances?: AccountBalance[];
    transferLimits?: TransferLimit[];
    activeCurrency?: string;
}

interface PropsFromDispatch {
    fetchContent: typeof fetchContent;
    fetchSettings: typeof fetchSettings;
}


const mapStateToProps = (app : AppState) => {
    return {
        isFetching: app.contentful.isFetching,
        error: app.contentful.error,
        settings: app.settings.settings,
        loggedIn : getLoggedIn(app),
        user: app.user.user,
        balances : app.user.balances,
        transferLimits : app.settings.settings && app.settings.settings.transferLimits,
        activeCurrency : app.payments.withdraw && app.payments.withdraw.activeCurrency
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        fetchContent: (contentModelName: ContentModelName, locale?: string) => dispatch(fetchContent(contentModelName, locale) as any),
        fetchSettings: () => dispatch(fetchSettings() as any),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(ProfilePage)